import { NAVY } from 'styles/tokens';

/** Shared sx overrides applied to every DateCalendar instance rendered inside the
 *  MasterFilter popovers. Keeps the typography, day-label color, and arrow styling
 *  aligned across `DateRangePicker` and `MetaPeriodPicker`. */
export const BASE_CALENDAR_SX = {
  width: 280,
  '& .MuiPickersCalendarHeader-label': {
    fontFamily: 'Jost, sans-serif',
    fontWeight: 600,
    fontSize: '0.9rem',
    color: NAVY,
  },
  '& .MuiDayCalendar-weekDayLabel': {
    fontFamily: 'Jost, sans-serif',
    color: `${NAVY}60`,
    fontSize: '0.75rem',
  },
  '& .MuiPickersDay-today': {
    border: 'none !important',
  },
  '& .MuiPickersArrowSwitcher-button': {
    color: NAVY,
  },
} as const;
